import React from 'react';
import { Container, Content } from './styles';
import { TextField, Skeleton } from '@gerdau/hefesto';
import { UploadFile } from '@gerdau/hefesto-mais-web';
import NumberFormat from 'react-number-format';

interface IRenewCreditUploadDocsModalContentProps {
  renewValue: number;
  setNewCreditLimit(renewValue: number): void;
  setCreditRenewDocs(docs: File[]): void;
  loading: boolean;
}

const RenewCreditUploadDocsModalContent: React.FC<
  IRenewCreditUploadDocsModalContentProps
> = ({ renewValue, setNewCreditLimit, setCreditRenewDocs, loading }) => {
  return (
    <Container>
      <header>
        <span className="subtitle">
          Sua solicitação de renovação de crédito será processada em até 3 dias
          após o envio.
        </span>
      </header>

      <Content>
        <div className="item">
          {loading ? (
            <Skeleton type="input" />
          ) : (
            <TextField
              name="input"
              placeholder={'R$ 0,00'}
              label="Valor do limite a solicitar"
              type="text"
              className="textFieldLimitValue"
              disabled={loading}
              children={
                <NumberFormat
                  name="inputRenewValue"
                  className="ant-input-borderless"
                  decimalSeparator={','}
                  thousandSeparator={'.'}
                  prefix={'R$ '}
                  suffix={',00'}
                  placeholder={'R$ 0,00'}
                  value={renewValue}
                  onValueChange={(values) =>
                    setNewCreditLimit(Number(values.value))
                  }
                  disabled={loading}
                />
              }
            ></TextField>
          )}
        </div>

        <div className="item">
          <span className="item-title">
            Para solicitações acima de R$ 250.000,00 é necessário o envio dos
            documentos abaixo:
          </span>

          <span className="doc-item">
            • Contrato social com a última alteração;
          </span>
          <span className="doc-item">
            • Últimos dois balanços e demonstrativos de resultado consolidados
            assinados;
          </span>
          <span className="doc-item">
            • Balancete mais atualizado do ano corrente, assinato;
          </span>
          <span className="doc-item">• Parecer comercial</span>

          <div className="upload-area">
            <UploadFile
              acceptedFiles={{
                'application/pdf': ['.pdf'],
                'application/msword': ['.doc'],

                'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                  ['.docx']
              }}
              maxSizeMB={5}
              onChangeFiles={(files) => setCreditRenewDocs(files)}
              disabled={loading || renewValue <= 250000}
            />
          </div>
        </div>
      </Content>
    </Container>
  );
};

export default RenewCreditUploadDocsModalContent;
